import { createFileRoute } from '@tanstack/react-router'

import { NetworkPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/network',
)({
  component: NetworkPage,
})
